"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CookiesAlert;
var _react = _interopRequireWildcard(require("react"));
var _io = require("react-icons/io");
var _CookieParameter = _interopRequireDefault(require("Components/Cookies/CookieParameter"));
var _CookiesDetailsMotal = _interopRequireDefault(require("Modals/CookiesDetailsMotal"));
var _CookiesStore = _interopRequireDefault(require("Components/Stores/CookiesStore"));
var _disableAllCookies = _interopRequireDefault(require("Components/StoresFunctions/disableAllCookies"));
var _enableAllCookies = _interopRequireDefault(require("Components/StoresFunctions/enableAllCookies"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const is__prerendered = document.querySelector('meta[rel="x-prerender-render-id"]') ? true : false;
function CookiesAlert() {
  const ref = (0, _react.useRef)();
  const [hidden, setHidden] = (0, _react.useState)(is__prerendered ? true : window.localStorage.getItem('cookies_consent') ? true : false);
  (0, _react.useEffect)(function () {
    if (is__prerendered) {
      return window.localStorage.setItem('cookies_consent', 'true');
    }
    ref.current = {};
    ref.current.openCookiesBanner = function () {
      if (is__prerendered) return;
      setHidden(false);
    };
    ref.current.accept = function () {
      window.localStorage.setItem('cookies_consent', 'true');
      (0, _enableAllCookies.default)();
      setHidden(true);
    };
    ref.current.refuse = function () {
      window.localStorage.setItem('cookies_consent', 'false');
      (0, _disableAllCookies.default)();
      setHidden(true);
    };
  }, [ref]);
  (0, _react.useEffect)(function () {
    window.openCookiesBanner = function (e) {
      if (is__prerendered) return;
      ref.current?.openCookiesBanner?.();
    };
    if (is__prerendered) return ref.current?.refuse?.();
    ;
    const user_consent = window.localStorage.getItem('cookies_consent');
    if (user_consent === 'false') {
      return ref.current?.refuse?.();
    } else if (user_consent === 'true') {
      return ref.current?.accept?.();
    }
  }, []);
  const accept = (0, _react.useCallback)(function (e) {
    ref.current.accept?.();
  }, []);
  const refuse = (0, _react.useCallback)(function (e) {
    ref.current.refuse?.();
  }, []);
  const hideAlert = (0, _react.useCallback)(function (e) {
    setHidden(true);
  }, []);
  if (is__prerendered) return null;
  let output = hidden ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: "o-cookies-alert"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "o-cookies-alert__text"
  }, "Nous utilisons des cookies \xE0 des fins de mesure d'audience."), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: (0, _bemit.default)('c-button', ['green', 'cookies-footer']),
    onClick: accept
  }, "Accepter"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: (0, _bemit.default)('c-button', ['red', 'cookies-footer']),
    onClick: refuse
  }, "Refuser"), /*#__PURE__*/_react.default.createElement(CookiesAlertCustomBtn, null));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, output, /*#__PURE__*/_react.default.createElement(_CookieParameter.default, {
    code: "google_analytics"
  }), /*#__PURE__*/_react.default.createElement(_CookiesDetailsMotal.default, {
    onClose: hideAlert
  }));
}

// eslint-disable-next-line react/no-multi-comp
function CookiesAlertCustomBtn({
  lang
}) {
  const openDetails = (0, _react.useCallback)(function (e) {
    e.persist();
    _CookiesStore.default.update(function (store) {
      store.open = true;
      store.trg = e.target;
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: (0, _bemit.default)('c-button', ['white', 'cookies-footer']),
    onClick: openDetails
  }, /*#__PURE__*/_react.default.createElement(_io.IoMdSwitch, {
    className: "c-button__icon"
  }), "Affiner mes choix");
}
function isDoNotTrackEnabled() {
  const enabled = [window.navigator.doNotTrack === '1', window.navigator.doNotTrack === 'yes', window.doNotTrack === '1', window.doNotTrack === 'yes', window.navigator.globalPrivacyControl].some(condition => condition);
  return enabled;
}
